/**
 * Formats a number in Indian numbering system (e.g. 9,68,351.30).
 */
export function formatIndianNumber(value, options = {}) {
  const num = Number(value);
  if (Number.isNaN(num)) {
    return options.fallback ?? '0.00';
  }

  const {
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
  } = options;

  return num.toLocaleString('en-IN', {
    minimumFractionDigits,
    maximumFractionDigits,
  });
}
